// src/sagas/libraryCardSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_LIBRARY_CARD_REQUEST,
  UPDATE_LIBRARY_CARD_REQUEST,
} from "../actions/types";
import {
  getLibraryCardSuccess,
  getLibraryCardFailure,
  updateLibraryCardSuccess,
  updateLibraryCardFailure,
} from "../actions/libraryCardActions";
import { fetchLibraryCardFromApi, saveLibraryCardToApi } from "../apis/libraryCardApi";

function* getLibraryCardSaga(action) {
  try {
    const { tenantId, entityType, entityId } = action.payload;
    const card = yield call(fetchLibraryCardFromApi, { tenantId, entityType, entityId });
    yield put(getLibraryCardSuccess(card?.payload || null));
  } catch (err) {
    console.error("libraryCardSaga - getLibraryCard error:", err);
    yield put(getLibraryCardFailure(err.message));
  }
}

function* updateLibraryCardSaga(action) {
  try {
    const card = yield call(saveLibraryCardToApi, action.payload);
    yield put(updateLibraryCardSuccess(card?.payload || null));
  } catch (err) {
    console.error("libraryCardSaga - updateLibraryCard error:", err);
    yield put(updateLibraryCardFailure(err.message));
  }
}

export default function* libraryCardSaga() {
  yield takeLatest(GET_LIBRARY_CARD_REQUEST, getLibraryCardSaga);
  yield takeLatest(UPDATE_LIBRARY_CARD_REQUEST, updateLibraryCardSaga);
}
